import { FORM_ELEMENT_TYPES } from '../FormCreator/FormElements.types';

const FilterDefinitionTypes = {
  VALUE: FORM_ELEMENT_TYPES.TEXT,
  VALUE_NUMBER: FORM_ELEMENT_TYPES.NUMBER,
  VALID_VALUES: FORM_ELEMENT_TYPES.DROPDOWN,
  BOOLEAN: FORM_ELEMENT_TYPES.CHECKBOX,
  DATE: FORM_ELEMENT_TYPES.DATE
};

export default FilterDefinitionTypes;
